<template>
  <v-card>
    <v-treeview
      activatable
      ref="field_treeview"
      item-key="id"
      :items="fields"
      :active="selected_field"
      @update:active="$emit('update_selected_field', $event)"
    ></v-treeview>
  </v-card>
</template>

<script>
export default {
  name: 'field_select',
  props: {
    source_lang: String,
    target_lang: String,
    type: String,
    selected_field: Array
  },
  data: function(){
    return {
      module_id: "72",
      langs: [
        "en",
        "ja"
      ]
    }
  },
  computed: {
    fields_data: function(){
      // 加工しながらfield_dataに格納
      function make_field_node(lid, lid_data, lid_node){
        if(lid_data[lid]["children"].length == 0 && !lid_data[lid]["available"]){
          return;
        }
        var field_node = {};
        if(lid_data[lid]["children"].length > 0){
          field_node["children"] = [];
          for(var child of lid_data[lid]["children"]){
            make_field_node(child, lid_data, lid !== "root" ? field_node["children"] : lid_node);
          }
        }
        if(lid !== "root"){
          field_node["id"] = lid;
          field_node["name"] = lid_data[lid]["name"];
          lid_node.push(field_node);
        }
      }
      var result = {};
      for(var lang of this.langs){
        result[lang] = {};
        for(var source_lang in this.$store.getters.lang_pairs[this.type]){
          for(var target_lang of this.$store.getters.lang_pairs[this.type][source_lang]){
            var current_lang_pair = source_lang + "_" + target_lang;
            result[lang][current_lang_pair] = [];
            make_field_node("root", this.$store.getters.fields[this.type][lang][current_lang_pair], result[lang][current_lang_pair])
          }
        }
      }
      return result;
    },
    fields: function(){
      var lang = this.$i18n.locale;
      if(!this.fields_data){
        return [];
      }else if(!this.fields_data[lang]){
        lang = "en";
      }
      var lang_pair = this.source_lang + "_" + this.target_lang;
      if(!this.fields_data[lang][lang_pair]){
        return [];
      }
      return this.fields_data[lang][lang_pair];
    }
  }
}
</script>
